module.exports = __webpack_public_path__ + "images/category_lp/common/icon-voice-man-10@2x_15126588a258a48eade2283f82ec7696.png";